(function () {
  if (window.__mhHomepageDynRan) return;
  window.__mhHomepageDynRan = true;

  var ROOT = document.querySelector('[data-mh-dynamic-root]');
  if (!ROOT) return;

  // ─── CLS guard: reserve last-known height before fetch resolves ───────
  // The dynamic homepage fetches /api/homepage_full.php and injects ~6-10
  // sections AFTER first paint, pushing content below it down by hundreds
  // of px. CLS=1.37 origin-wide. Mitigation: stash the rendered height
  // (per viewport-bucket) in localStorage and apply it as min-height on
  // the very next page load, BEFORE the fetch resolves. Returning visitors
  // see the page at full height from first paint — no shift when content
  // fills in.
  //
  // Bucketed by viewport width so a phone visit doesn't reserve a tablet
  // height (the dynamic sections stack differently across breakpoints).
  var MH_HEIGHT_KEY = 'mh_dyn_home_h_v1';
  function mhBucket(w) {
    if (w < 480) return 'xs';
    if (w < 768) return 'sm';
    if (w < 1024) return 'md';
    return 'lg';
  }
  try {
    var stored = JSON.parse(localStorage.getItem(MH_HEIGHT_KEY) || '{}');
    var h = stored[mhBucket(window.innerWidth)];
    if (h && h > 200 && h < 12000) {
      // Apply with a sane cap so a freak measurement can't blow up.
      ROOT.style.minHeight = h + 'px';
      ROOT.dataset.mhHeightRestored = '1';
    }
  } catch (e) {}

  // Drop the min-height once content has rendered + images settle, so
  // future responsive resizing works naturally. We measure + store the
  // real height at the same time for the NEXT visit.
  function mhReleaseAndStore() {
    try {
      var realH = ROOT.scrollHeight;
      if (realH > 200 && realH < 12000) {
        var s = JSON.parse(localStorage.getItem(MH_HEIGHT_KEY) || '{}');
        s[mhBucket(window.innerWidth)] = realH;
        localStorage.setItem(MH_HEIGHT_KEY, JSON.stringify(s));
      }
      // Only drop the reservation AFTER we've stored the real height so
      // there's no flash. Use rAF for paint sync.
      requestAnimationFrame(function () {
        ROOT.style.minHeight = '';
      });
    } catch (e) {}
  }
  // Hook into the fetch chain — we know the renderer finishes in the
  // homepage_full .then() below. Use a window event the renderer can fire,
  // OR fall back to a delayed measurement.
  window.addEventListener('mh:homepage-dyn-rendered', mhReleaseAndStore);
  // Defensive fallback: if the event never fires (e.g. API down), drop
  // the reservation after 6s so we don't leave dead whitespace.
  setTimeout(function () {
    if (ROOT.dataset.mhHeightRestored === '1') mhReleaseAndStore();
    // Never leave the boot skeleton shimmering forever if the API is down.
    var sk = ROOT.querySelector('[data-mh-boot-skel]');
    if (sk) sk.remove();
  }, 8000);

  // The dynamic renderer reshuffles section wrappers after fetch, so
  // any scroll position the browser restored will no longer correspond
  // to the same visible content. Disable scroll restoration on the
  // homepage and pin to top across multiple lifecycle events so the
  // user always lands at the hero regardless of when reflow happens
  // (initial parse, fetch resolve, image loads, Slick init, etc.).
  if ('scrollRestoration' in history) {
    try { history.scrollRestoration = 'manual'; } catch (e) {}
  }
  function pinTop() { try { window.scrollTo(0, 0); } catch (e) {} }
  // Immediate (overrides any restoration that already happened).
  pinTop();
  // After current micro/macro task — handles browsers that restore
  // scroll just after script execution.
  setTimeout(pinTop, 0);
  // After window.load — last layout shifts from images/Slick are done.
  window.addEventListener('load', function () {
    pinTop();
    setTimeout(pinTop, 100);
  });
  // pageshow fires for both fresh navigations and bfcache restores.
  window.addEventListener('pageshow', pinTop);

  // Renderer registry. Each entry is fn(section, container) → bool.
  // Returning false skips appending the shell (useful for empty data).
  var Renderers = {};

  // ─────────────────────── shell helpers ───────────────────────

  function cloneSvg(name) {
    var tmpl = document.querySelector('template[data-mh-dyn-svg="' + name + '"]');
    if (!tmpl) return null;
    return tmpl.content.firstChild.cloneNode(true);
  }

  function makeArrow(direction) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'mh-dyn-arrow mh-dyn-arrow--' + direction;
    btn.setAttribute('data-arrow', direction);
    btn.setAttribute('aria-label', direction === 'prev' ? 'Previous' : 'Next');
    var svg = cloneSvg(direction);
    if (svg) btn.appendChild(svg);
    return btn;
  }

  function applySectionBg(wrapper, section) {
    var start = (section.bg_gradient_start || '').trim();
    var end   = (section.bg_gradient_end   || '').trim();
    var solid = (section.background_color  || '').trim().toLowerCase();
    if (start && end) {
      wrapper.style.background = 'linear-gradient(to bottom, ' + start + ' 0%, ' + end + ' 100%)';
    } else if (solid && solid !== '#fff' && solid !== '#ffffff' && solid !== '#fafafa') {
      wrapper.style.background = section.background_color;
    }
  }

  // Section types where the shared title chrome doesn't fit — full-bleed
  // hero banners and 3-zone layouts have their own internal headings.
  var SUPPRESS_HEADER = { banner_carousel_pair: 1, banner_row: 1, two_column: 1, triple_zone_mega_deals: 1, promo_strip: 1, tile_carousel: 1 };

  // Section types that opt out of the .mh-dyn-section-inner max-width
  // wrapper. Banner-row hero banners need full-bleed.
  var FULL_BLEED = { banner_carousel_pair: 1, promo_strip: 1 };

  function buildShell(section) {
    var wrapper = document.createElement('section');
    wrapper.className = 'mh-dyn-section mh-dyn-section--' + (section.section_type || 'unknown');
    wrapper.setAttribute('data-mh-section-type', section.section_type || '');
    wrapper.setAttribute('data-mh-section-slug', section.slug || '');
    applySectionBg(wrapper, section);

    var inner = document.createElement('div');
    inner.className = FULL_BLEED[section.section_type] ? 'mh-dyn-section-fullbleed' : 'mh-dyn-section-inner';
    wrapper.appendChild(inner);

    var viewAll = null;
    if (section.title && !SUPPRESS_HEADER[section.section_type]) {
      var hd = document.createElement('div');
      hd.className = 'mh-dyn-header';
      var h2 = document.createElement('h2');
      h2.className = 'mh-dyn-title';
      h2.textContent = section.title;
      hd.appendChild(h2);
      // Pre-mount a hidden view-all on the right; renderers can fill
      // its href + unhide it. Keeps title left, view-all right at all
      // times for consistent layout.
      viewAll = document.createElement('a');
      viewAll.className = 'mh-dyn-viewall';
      viewAll.hidden = true;
      viewAll.textContent = mhIsAr ? 'عرض الكل' : 'VIEW ALL';
      var chev = cloneSvg('next');
      if (chev) viewAll.appendChild(chev);
      hd.appendChild(viewAll);
      inner.appendChild(hd);
    }

    var body = document.createElement('div');
    body.className = 'mh-dyn-body';
    inner.appendChild(body);

    return { wrapper: wrapper, body: body, viewAll: viewAll };
  }

  // ── RTL-aware horizontal carousel scrolling ──────────────────────────────
  // In RTL, scrollLeft uses the negative model (0 → -span) and smooth
  // scrollBy/scrollTo with a negative target are no-ops in Chrome. So animate
  // manually with per-frame instant scrollLeft (works in every scroll model),
  // and compute disabled states against the correct min/max bounds.
  // Direction check that works even for not-yet-attached nodes (a detached
  // element's computed direction is '' -> silently treated as LTR, which froze
  // the /ar marquees at the scrollLeft 0 boundary). html[dir] is set by
  // Shopify on every locale render and never lies.
  function mhIsRtlNow() {
    return (document.documentElement.getAttribute('dir') || '').toLowerCase() === 'rtl';
  }
  function mhCarBounds(track) {
    var span = track.scrollWidth - track.clientWidth;
    return mhIsRtlNow() ? { min: -span, max: 0 } : { min: 0, max: span };
  }
  function mhCarScroll(track, dir, stepPx) {        // dir: -1 = prev (‹), +1 = next (›)
    var b = mhCarBounds(track);
    var step = stepPx || Math.round(track.clientWidth * 0.85);
    var target = Math.max(b.min, Math.min(b.max, track.scrollLeft + dir * step));
    var startL = track.scrollLeft, dist = target - startL, t0 = null;
    if (!dist) return;
    function frame(ts) {
      if (t0 === null) t0 = ts;
      var p = Math.min((ts - t0) / 350, 1);
      track.scrollLeft = startL + dist * (1 - Math.pow(1 - p, 3));
      if (p < 1) requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }
  function mhCarSync(track, prevBtn, nextBtn) {
    var b = mhCarBounds(track), sl = track.scrollLeft;
    if (prevBtn) prevBtn.toggleAttribute('disabled', sl <= b.min + 1);
    if (nextBtn) nextBtn.toggleAttribute('disabled', sl >= b.max - 1);
  }

  // Animate to an explicit target WITHOUT clamping — for LOOPING marquees
  // (tile_carousel / brand_slider) whose track is duplicated. Clamping made
  // an arrow silently dead: RTL starts at scrollLeft 0, which IS the clamp
  // boundary, so "next" never moved on /ar.
  function mhCarScrollTo(track, target) {
    var startL = track.scrollLeft, dist = target - startL, t0 = null;
    if (!dist) return;
    function frame(ts) {
      if (t0 === null) t0 = ts;
      var p = Math.min((ts - t0) / 350, 1);
      track.scrollLeft = startL + dist * (1 - Math.pow(1 - p, 3));
      if (p < 1) requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  // Arrow step for a looping marquee: mirror direction in RTL (forward =
  // negative scrollLeft) and wrap into the duplicated half so neither
  // arrow ever hits a dead edge.
  function mhMarqueeArrow(viewport, track, dirBtn, stepPx) {
    var sgnr = mhIsRtlNow() ? -1 : 1;
    var step = stepPx * dirBtn * sgnr;
    var half = track.scrollWidth / 2;
    if (half > 0) {
      var nextPos = (viewport.scrollLeft + step) * sgnr;   // magnitude after move
      if (nextPos < 0) viewport.scrollLeft = viewport.scrollLeft + half * sgnr;
      else if (nextPos > half) viewport.scrollLeft = viewport.scrollLeft - half * sgnr;
    }
    mhCarScrollTo(viewport, viewport.scrollLeft + step);
  }

  function wireArrows(wrap, trackEl) {
    var prev = wrap.querySelector('[data-arrow="prev"]');
    var next = wrap.querySelector('[data-arrow="next"]');
    if (!prev || !next || !trackEl) return;
    prev.addEventListener('click', function () { mhCarScroll(trackEl, -1); });
    next.addEventListener('click', function () { mhCarScroll(trackEl, 1); });
    trackEl.addEventListener('scroll', function () { mhCarSync(trackEl, prev, next); }, { passive: true });
    mhCarSync(trackEl, prev, next);
  }

  // ─────────────────────── brand_slider ───────────────────────

  function makeBrandTile(b) {
    var div = document.createElement('div');
    div.className = 'mh-dyn-bs-tile';
    var img = document.createElement('img');
    img.src = b.logo || '';
    img.alt = b.name || 'Brand';
    img.setAttribute('loading', 'lazy');
    if (b.url) {
      var a = document.createElement('a');
      a.href = b.url;
      a.setAttribute('aria-label', b.name || 'Brand');
      a.title = b.name || '';
      a.appendChild(img);
      div.appendChild(a);
    } else {
      div.appendChild(img);
    }
    return div;
  }

  Renderers.brand_slider = function (section, body) {
    // Populate the shared shell view-all so it points at the all-brands
    // landing page (works on every breakpoint).
    var shellViewAll = body.parentElement && body.parentElement.querySelector('.mh-dyn-viewall');
    if (shellViewAll) {
      shellViewAll.href = '/pages/brands';
      shellViewAll.hidden = false;
    }

    // Brands are sourced from /admin/brands (homepage-active list),
    // NOT from the section's tiles. The admin brand record provides
    // a higher-quality logo and the canonical /collections/<slug> URL.
    var wrap = document.createElement('div');
    wrap.className = 'mh-dyn-bs-wrap';
    wrap.appendChild(makeArrow('prev'));
    var track = document.createElement('div');
    track.className = 'mh-dyn-bs-track';
    wrap.appendChild(track);
    wrap.appendChild(makeArrow('next'));
    body.appendChild(wrap);

    fetch('https://admin.menahub.com/api/brands_v2.php?homepage=1', { credentials: 'omit' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (json) {
        var brands = (json && json.success && json.brands) || [];
        // Only brands with a logo are renderable.
        brands = brands.filter(function (b) { return b && b.logo; });
        if (!brands.length) {
          var sec = body.closest('.mh-dyn-section');
          if (sec) sec.style.display = 'none';
          return;
        }
        brands.forEach(function (b) { track.appendChild(makeBrandTile(b)); });
        var loopCopy = document.createElement('div');
        loopCopy.className = 'mh-dyn-bs-loop-copy';
        loopCopy.setAttribute('aria-hidden', 'true');
        brands.forEach(function (b) { loopCopy.appendChild(makeBrandTile(b)); });
        track.appendChild(loopCopy);
        startBrandMarquee();
      })
      .catch(function () {
        var sec = body.closest('.mh-dyn-section');
        if (sec) sec.style.display = 'none';
      });

    function startBrandMarquee() {

    var direction = section.scroll_direction === 'reverse' ? -1 : 1;
    var pxPerFrame = 0.45;
    var paused = false;
    var resumeTimer = null;
    function pauseFor(ms) {
      paused = true;
      if (resumeTimer) clearTimeout(resumeTimer);
      if (ms > 0) resumeTimer = setTimeout(function () { paused = false; }, ms);
    }
    function resume() {
      if (resumeTimer) { clearTimeout(resumeTimer); resumeTimer = null; }
      paused = false;
    }
    track.addEventListener('mouseenter', function () { pauseFor(0); });
    track.addEventListener('mouseleave', resume);
    track.addEventListener('touchstart', function () { pauseFor(0); }, { passive: true });
    track.addEventListener('touchend', function () { pauseFor(1500); }, { passive: true });
    track.addEventListener('wheel', function () { pauseFor(1500); }, { passive: true });

    // Click + drag for desktop swipe-feel
    var DRAG_THRESHOLD = 5;
    var pointerDown = false, dragging = false, startX = 0, startScroll = 0;
    track.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      pointerDown = true; dragging = false;
      startX = e.pageX; startScroll = track.scrollLeft;
      pauseFor(0);
    });
    window.addEventListener('mousemove', function (e) {
      if (!pointerDown) return;
      var dx = e.pageX - startX;
      if (!dragging && Math.abs(dx) > DRAG_THRESHOLD) {
        dragging = true; track.classList.add('is-dragging');
      }
      if (dragging) { e.preventDefault(); track.scrollLeft = startScroll - dx; }
    });
    window.addEventListener('mouseup', function () {
      if (!pointerDown) return;
      pointerDown = false;
      if (dragging) {
        track.classList.remove('is-dragging');
        track.addEventListener('click', function s(e) {
          e.stopPropagation(); e.preventDefault();
          track.removeEventListener('click', s, true);
        }, true);
      }
      dragging = false;
      pauseFor(1500);
    });

    // Prev/Next arrows
    var prev = wrap.querySelector('[data-arrow="prev"]');
    var next = wrap.querySelector('[data-arrow="next"]');
    if (prev) prev.addEventListener('click', function () {
      var first = track.querySelector('.mh-dyn-bs-tile');
      var w = first ? first.getBoundingClientRect().width : 200;
      pauseFor(3000);
      mhMarqueeArrow(track, track, -1, (w + 16) * 3);
    });
    if (next) next.addEventListener('click', function () {
      var first = track.querySelector('.mh-dyn-bs-tile');
      var w = first ? first.getBoundingClientRect().width : 200;
      pauseFor(3000);
      mhMarqueeArrow(track, track, 1, (w + 16) * 3);
    });

    var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    // RTL uses the negative scrollLeft model (0 → -span), so mirror every
    // increment/bound with sgn — otherwise the marquee freezes at 0 on /ar.
    function tick() {
      var sgn = mhIsRtlNow() ? -1 : 1;
      if (!paused) {
        track.scrollLeft += pxPerFrame * direction * sgn;
        var half = track.scrollWidth / 2;
        if (half > 0) {
          var pos = track.scrollLeft * sgn;            // magnitude 0..half
          if (direction > 0 && pos >= half) track.scrollLeft -= half * sgn;
          else if (direction < 0 && pos <= 0) track.scrollLeft += half * sgn;
        }
      }
      requestAnimationFrame(tick);
    }
    if (!prefersReduced) {
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if (direction < 0) {
            var half = track.scrollWidth / 2;
            if (half > 0) track.scrollLeft = half * (mhIsRtlNow() ? -1 : 1);
          }
          tick();
        });
      });
    }
    } // end startBrandMarquee
    return true;
  };

  // ─────────────────────── service_strip ───────────────────────

  Renderers.service_strip = function (section, body) {
    var tiles = section.tiles || [];
    if (!tiles.length) return false;
    var grid = document.createElement('div');
    grid.className = 'mh-dyn-ss-grid';
    // Use a CSS variable for desktop column count instead of an inline
    // grid-template-columns rule — inline styles win over our @media
    // queries and were forcing 4 columns on mobile, squeezing each tile
    // so narrow that text wrapped one letter per line.
    grid.style.setProperty('--ss-cols', String(Math.min(tiles.length, 4)));
    tiles.forEach(function (t) {
      var wrap = t.href ? document.createElement('a') : document.createElement('div');
      wrap.className = 'mh-dyn-ss-tile';
      if (t.href) wrap.href = t.href;
      var iconBox = document.createElement('div');
      iconBox.className = 'mh-dyn-ss-icon';
      if (t.image_url) {
        var img = document.createElement('img');
        img.src = t.image_url; img.alt = t.title || '';
        img.setAttribute('loading', 'lazy');
        iconBox.appendChild(img);
      }
      var textBox = document.createElement('div');
      textBox.className = 'mh-dyn-ss-text';
      var title = document.createElement('p');
      title.className = 'mh-dyn-ss-title';
      title.textContent = t.title || '';
      textBox.appendChild(title);
      if (t.subtitle) {
        var sub = document.createElement('p');
        sub.className = 'mh-dyn-ss-sub';
        sub.textContent = t.subtitle;
        textBox.appendChild(sub);
      }
      wrap.appendChild(iconBox);
      wrap.appendChild(textBox);
      grid.appendChild(wrap);
    });
    body.appendChild(grid);
    return true;
  };

  // ── Shared: prev/next arrow buttons for a carousel host ──────────────
  function mhMakeArrows(host) {
    var NS = 'http://www.w3.org/2000/svg';
    function btn(dir) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'mh-car-arrow mh-car-arrow--' + dir;
      b.setAttribute('aria-label', dir === 'prev' ? 'Previous banner' : 'Next banner');
      var svg = document.createElementNS(NS, 'svg');
      svg.setAttribute('viewBox', '0 0 24 24');
      svg.setAttribute('width', '18'); svg.setAttribute('height', '18');
      svg.setAttribute('fill', 'none'); svg.setAttribute('stroke', 'currentColor');
      svg.setAttribute('stroke-width', '2.6');
      svg.setAttribute('stroke-linecap', 'round'); svg.setAttribute('stroke-linejoin', 'round');
      var path = document.createElementNS(NS, 'path');
      path.setAttribute('d', dir === 'prev' ? 'M15 18l-6-6 6-6' : 'M9 18l6-6-6-6');
      svg.appendChild(path);
      b.appendChild(svg);
      return b;
    }
    var prev = btn('prev'), next = btn('next');
    host.appendChild(prev);
    host.appendChild(next);
    return { prevBtn: prev, nextBtn: next };
  }

  // ── Shared: transform-based INFINITE loop carousel ───────────────────
  // Wraps continuously in BOTH directions (drag/swipe left or right never
  // hits a wall) by cloning the first & last real slides onto the opposite
  // ends and teleporting — invisibly, since transform has no scrollbar —
  // whenever a clone is reached. Movable by touch swipe and mouse drag;
  // optional prev/next arrows; auto-advances while the mobile media query
  // matches and the user isn't interacting.
  //   track      : the flex row whose children are the real slides
  //   realCount  : number of real slides currently in `track`
  //   autoMedia  : matchMedia gating auto-advance + drag (mobile)
  //   opts       : { cloneClass, prevBtn, nextBtn, interval, slideMs }
  function mhLoopCarousel(track, realCount, autoMedia, opts) {
    if (!track || realCount < 2) return;
    opts = opts || {};
    var interval = opts.interval || 3500;
    var slideMs  = opts.slideMs  || 450;
    var reduce   = window.matchMedia('(prefers-reduced-motion: reduce)');

    // Clone last → prepend, first → append. Real slide i now sits at DOM
    // index i+1; clones are hidden on desktop via the .mh-loop-clone CSS.
    var reals = Array.prototype.slice.call(track.children);
    function mkClone(node) {
      var c = node.cloneNode(true);
      c.classList.add('mh-loop-clone');
      if (opts.cloneClass) c.classList.add(opts.cloneClass);
      c.setAttribute('aria-hidden', 'true');
      c.setAttribute('tabindex', '-1');
      return c;
    }
    track.insertBefore(mkClone(reals[realCount - 1]), reals[0]);
    track.appendChild(mkClone(reals[0]));

    var count = realCount;
    var index = 1;                 // start on the first REAL slide
    var timer = null, resetT = null, resume = null;
    var down = false, sx = 0, baseTx = 0, w = 0, moved = false;

    function setTx(pct, animate) {
      track.style.transition = animate ? ('transform ' + slideMs + 'ms ease') : 'none';
      track.style.transform = 'translateX(' + pct + '%)';
    }
    function goTo(i, animate) {
      index = i;
      setTx(-(i * 100), animate);
      if (animate && (i === 0 || i === count + 1)) {
        // Landed on a clone → after the slide, jump to its identical twin
        // real slide with animation off. Invisible = continuous loop.
        if (resetT) clearTimeout(resetT);
        resetT = setTimeout(function () {
          index = (i === 0) ? count : 1;
          setTx(-(index * 100), false);
        }, slideMs + 40);
      }
    }
    function next() { goTo(index + 1, true); }
    function prev() { goTo(index - 1, true); }

    function startAuto() { if (!timer && autoMedia.matches && !reduce.matches) timer = setInterval(next, interval); }
    function stopAuto()  { if (timer) { clearInterval(timer); timer = null; } }
    function pauseResume() { stopAuto(); if (resume) clearTimeout(resume); resume = setTimeout(startAuto, 1800); }

    // Drag / swipe (pointer events cover mouse + touch + pen). Mobile only.
    track.addEventListener('pointerdown', function (e) {
      if (!autoMedia.matches) return;
      down = true; moved = false; sx = e.clientX;
      w = track.getBoundingClientRect().width || 1;
      baseTx = -(index * 100);
      stopAuto();
      if (resetT) { clearTimeout(resetT); resetT = null; }
      track.classList.add('mh-dragging');
      setTx(baseTx, false);
      try { track.setPointerCapture(e.pointerId); } catch (_) {}
    });
    track.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dxPx = e.clientX - sx;
      if (Math.abs(dxPx) > 4) moved = true;
      setTx(baseTx + (dxPx / w) * 100, false);   // follow finger/cursor
    });
    function release(e) {
      if (!down) return;
      down = false;
      track.classList.remove('mh-dragging');
      var dxPx = (e && typeof e.clientX === 'number') ? e.clientX - sx : 0;
      var thresh = w * 0.15;
      if (dxPx <= -thresh) next();          // dragged left  → next
      else if (dxPx >= thresh) prev();      // dragged right → prev
      else goTo(index, true);               // snap back
      pauseResume();
    }
    track.addEventListener('pointerup', release);
    track.addEventListener('pointercancel', release);
    // Swallow the click that follows a real drag so it doesn't navigate.
    track.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);
    track.addEventListener('mouseenter', stopAuto);
    track.addEventListener('mouseleave', startAuto);

    if (opts.prevBtn) opts.prevBtn.addEventListener('click', function (e) { e.preventDefault(); prev(); pauseResume(); });
    if (opts.nextBtn) opts.nextBtn.addEventListener('click', function (e) { e.preventDefault(); next(); pauseResume(); });

    function sync() {
      stopAuto();
      if (autoMedia.matches) {
        setTx(-(index * 100), false);   // ensure we sit on a real slide
        startAuto();
      } else {
        // Desktop: drop the inline transform so the static row / marquee show.
        track.style.transition = 'none';
        track.style.transform = '';
      }
    }
    setTx(-(index * 100), false);
    sync();
    if (autoMedia.addEventListener) autoMedia.addEventListener('change', sync);
    else if (autoMedia.addListener) autoMedia.addListener(sync);
    if (reduce.addEventListener) reduce.addEventListener('change', sync);
    else if (reduce.addListener) reduce.addListener(sync);
  }

  // ─────────────────────── banner_grid_3 ───────────────────────

  Renderers.banner_grid_3 = function (section, body) {
    var tiles = (section.tiles || []);
    if (!tiles.length) return false;
    function makeTile(t, isClone) {
      var alt = t.title || 'Banner';
      var imgD = document.createElement('img');
      imgD.src = t.image_url || ''; imgD.alt = alt;
      imgD.className = 'mh-dyn-bg3-desktop'; imgD.setAttribute('loading', 'lazy');
      var imgM = document.createElement('img');
      imgM.src = t.subtitle || t.image_url || ''; imgM.alt = alt;
      imgM.className = 'mh-dyn-bg3-mobile'; imgM.setAttribute('loading', 'lazy');
      var tile = document.createElement('div');
      tile.className = 'mh-dyn-bg3-tile' + (isClone ? ' mh-dyn-bg3-clone' : '');
      if (isClone) tile.setAttribute('aria-hidden', 'true');
      if (t.href) {
        var a = document.createElement('a');
        a.href = t.href; a.setAttribute('aria-label', alt);
        a.appendChild(imgD); a.appendChild(imgM);
        tile.appendChild(a);
      } else {
        tile.appendChild(imgD); tile.appendChild(imgM);
      }
      return tile;
    }

    // Desktop renders all tiles as a static row (CSS flex: 1). Mobile
    // shows one at a time and the JS below auto-advances the track.
    var viewport = document.createElement('div');
    viewport.className = 'mh-dyn-bg3-viewport';
    var track = document.createElement('div');
    track.className = 'mh-dyn-bg3-track';
    tiles.forEach(function (t) { track.appendChild(makeTile(t, false)); });
    viewport.appendChild(track);
    body.appendChild(viewport);

    // Mobile: infinite loop carousel — swipe/drag both ways (never stuck),
    // arrows, and auto-advance. Desktop stays the static 3-up row.
    if (tiles.length > 1) {
      var bg3Arrows = mhMakeArrows(viewport);
      mhLoopCarousel(track, tiles.length, window.matchMedia('(max-width: 768px)'), {
        cloneClass: 'mh-dyn-bg3-tile',
        prevBtn: bg3Arrows.prevBtn,
        nextBtn: bg3Arrows.nextBtn
      });
    }

    return true;
  };

  // ─────────────────────── banner_carousel_pair ───────────────────────

  Renderers.banner_carousel_pair = function (section, body) {
    var byZone = section.tiles_by_zone || {};
    var carousel = byZone.carousel || [];
    var staticT  = (byZone['static'] || [])[0] || null;
    if (!carousel.length && !staticT) return false;

    function makeImg(src, alt, klass, loading) {
      var img = document.createElement('img');
      img.src = src; img.alt = alt || 'Banner';
      img.className = klass;
      img.setAttribute('loading', loading);
      return img;
    }
    function buildSlide(tile, isFirst) {
      var alt = tile.title || 'Banner';
      var loading = isFirst ? 'eager' : 'lazy';
      var slide = document.createElement('div');
      slide.className = 'mh-dyn-bcp-slide';
      var imgD = makeImg(tile.image_url || '', alt, 'mh-dyn-bcp-img mh-dyn-bcp-desktop', loading);
      var imgM = makeImg(tile.subtitle || tile.image_url || '', alt, 'mh-dyn-bcp-img mh-dyn-bcp-mobile', loading);
      if (tile.href) {
        var a = document.createElement('a');
        a.href = tile.href; a.className = 'mh-dyn-bcp-link';
        a.setAttribute('aria-label', alt);
        a.appendChild(imgD); a.appendChild(imgM);
        slide.appendChild(a);
      } else {
        slide.appendChild(imgD); slide.appendChild(imgM);
      }
      return slide;
    }

    var wrap = document.createElement('div');
    wrap.className = 'mh-dyn-bcp';

    var carouselWrap = document.createElement('div');
    carouselWrap.className = 'mh-dyn-bcp-carousel';
    var track = document.createElement('div');
    track.className = 'mh-dyn-bcp-track';
    carousel.forEach(function (t, i) { track.appendChild(buildSlide(t, i === 0)); });
    carouselWrap.appendChild(track);
    var prevBtn = makeArrow('prev');
    prevBtn.classList.add('mh-dyn-bcp-arrow', 'mh-dyn-bcp-arrow--prev');
    prevBtn.classList.remove('mh-dyn-arrow', 'mh-dyn-arrow--prev');
    var nextBtn = makeArrow('next');
    nextBtn.classList.add('mh-dyn-bcp-arrow', 'mh-dyn-bcp-arrow--next');
    nextBtn.classList.remove('mh-dyn-arrow', 'mh-dyn-arrow--next');
    carouselWrap.appendChild(prevBtn);
    carouselWrap.appendChild(nextBtn);
    wrap.appendChild(carouselWrap);

    if (staticT) {
      var staticDiv = document.createElement('div');
      staticDiv.className = 'mh-dyn-bcp-static';
      var alt = staticT.title || 'Banner';
      var sD = makeImg(staticT.image_url || '', alt, 'mh-dyn-bcp-static-img mh-dyn-bcp-static-desktop', 'lazy');
      var sM = makeImg(staticT.subtitle || staticT.image_url || '', alt, 'mh-dyn-bcp-static-img mh-dyn-bcp-static-mobile', 'lazy');
      if (staticT.href) {
        var a = document.createElement('a');
        a.href = staticT.href; a.className = 'mh-dyn-bcp-link';
        a.setAttribute('aria-label', alt);
        a.appendChild(sD); a.appendChild(sM);
        staticDiv.appendChild(a);
      } else {
        staticDiv.appendChild(sD); staticDiv.appendChild(sM);
      }
      wrap.appendChild(staticDiv);
    }

    body.appendChild(wrap);

    // Carousel logic — autoplay, prev/next, swipe
    var slides = track.querySelectorAll('.mh-dyn-bcp-slide');
    if (slides.length > 1) {
      var idx = 0;
      function show(i) {
        idx = (i + slides.length) % slides.length;
        track.style.transform = 'translateX(' + (-idx * 100) + '%)';
      }
      var cfg = section.config || {};
      var autoplay = cfg.autoplay !== 0;
      var ms = parseInt(cfg.autoplay_ms, 10);
      if (isNaN(ms) || ms < 1500) ms = 3000;
      var timer = null;
      function resetTimer() {
        if (timer) clearInterval(timer);
        if (autoplay) timer = setInterval(function () { show(idx + 1); }, ms);
      }
      prevBtn.addEventListener('click', function () { show(idx - 1); resetTimer(); });
      nextBtn.addEventListener('click', function () { show(idx + 1); resetTimer(); });
      resetTimer();
      var touchX = 0;
      track.addEventListener('touchstart', function (e) { touchX = e.touches[0].clientX; }, { passive: true });
      track.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - touchX;
        if (Math.abs(dx) > 40) { show(dx < 0 ? idx + 1 : idx - 1); resetTimer(); }
      });
    } else {
      prevBtn.style.display = 'none';
      nextBtn.style.display = 'none';
    }

    return true;
  };

  // ─────────────────────── tile_carousel ───────────────────────

  function makeTileCarouselTile(t) {
    var a = document.createElement('a');
    a.href = t.href || '/collections/all';
    a.className = 'mh-dyn-tc-tile';
    a.setAttribute('aria-label', t.title || 'Shop category');
    var wrap = document.createElement('div');
    wrap.className = 'mh-dyn-tc-img-wrap';
    if (t.image_url) {
      var img = document.createElement('img');
      img.src = t.image_url; img.alt = t.title || '';
      // Eager-load category thumbnails. They're small and in a horizontal
      // scroller, where native lazy-loading leaves the just-off-screen / edge
      // tile blank (title only) until you scroll — so load them upfront.
      img.loading = 'eager'; img.setAttribute('fetchpriority', 'low');
      img.decoding = 'async'; img.className = 'mh-dyn-tc-img';
      img.width = 480; img.height = 480;
      wrap.appendChild(img);
    } else {
      var ph = document.createElement('div');
      ph.className = 'mh-dyn-tc-placeholder';
      ph.setAttribute('aria-hidden', 'true');
      ph.textContent = (t.title || '?').charAt(0).toUpperCase();
      wrap.appendChild(ph);
    }
    a.appendChild(wrap);
    var h3 = document.createElement('h3');
    h3.className = 'mh-dyn-tc-title';
    h3.textContent = t.title || '';
    a.appendChild(h3);
    return a;
  }

  Renderers.tile_carousel = function (section, body) {
    var tiles = section.tiles || [];
    if (!tiles.length) return false;

    var marquee = document.createElement('div');
    marquee.className = 'mh-dyn-tc-marquee';

    var prev = makeArrow('prev');
    prev.classList.add('mh-dyn-tc-nav', 'mh-dyn-tc-nav--prev');
    prev.classList.remove('mh-dyn-arrow', 'mh-dyn-arrow--prev');
    var next = makeArrow('next');
    next.classList.add('mh-dyn-tc-nav', 'mh-dyn-tc-nav--next');
    next.classList.remove('mh-dyn-arrow', 'mh-dyn-arrow--next');
    marquee.appendChild(prev);
    marquee.appendChild(next);

    var viewport = document.createElement('div');
    viewport.className = 'mh-dyn-tc-viewport';
    var track = document.createElement('div');
    track.className = 'mh-dyn-tc-track';
    function appendTileSet(target) {
      var set = document.createElement('div');
      set.className = 'mh-dyn-tc-loop-copy';
      set.setAttribute('aria-hidden', 'true');
      tiles.forEach(function (t) { set.appendChild(makeTileCarouselTile(t)); });
      target.appendChild(set);
    }
    tiles.forEach(function (t) { track.appendChild(makeTileCarouselTile(t)); });
    appendTileSet(track);
    viewport.appendChild(track);
    marquee.appendChild(viewport);
    body.appendChild(marquee);

    // Seamless-loop guard: the marquee wraps at HALF the track width, which
    // is only reachable when half ≥ the scrollable range. With few tiles
    // (track/2 < viewport) the forward marquee just drives into the end and
    // FREEZES at max scroll. Duplicate the tile set (in pairs, so the wrap
    // point stays content-aligned) until the loop actually works.
    requestAnimationFrame(function () {
      var guard = 0;
      while (track.scrollWidth / 2 <= viewport.clientWidth + 40 && guard < 8) {
        appendTileSet(track);
        appendTileSet(track);
        guard += 2;
      }
    });

    // Auto-scroll marquee
    var direction = section.scroll_direction === 'reverse' ? -1 : 1;
    var pxPerFrame = 0.45;
    var paused = false;
    var resumeTimer = null;
    function pauseFor(ms) {
      paused = true;
      if (resumeTimer) clearTimeout(resumeTimer);
      if (ms > 0) resumeTimer = setTimeout(function () { paused = false; }, ms);
    }
    function resume() {
      if (resumeTimer) { clearTimeout(resumeTimer); resumeTimer = null; }
      paused = false;
    }
    viewport.addEventListener('mouseenter', function () { pauseFor(0); });
    viewport.addEventListener('mouseleave', resume);
    viewport.addEventListener('touchstart', function () { pauseFor(0); }, { passive: true });
    viewport.addEventListener('touchend', function () { pauseFor(1500); }, { passive: true });
    viewport.addEventListener('wheel', function () { pauseFor(1500); }, { passive: true });

    // Drag to scroll
    var DRAG = 5, down = false, dragging = false, startX = 0, startScroll = 0;
    viewport.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      down = true; dragging = false;
      startX = e.pageX; startScroll = viewport.scrollLeft;
      pauseFor(0);
    });
    window.addEventListener('mousemove', function (e) {
      if (!down) return;
      var dx = e.pageX - startX;
      if (!dragging && Math.abs(dx) > DRAG) { dragging = true; viewport.classList.add('is-dragging'); }
      if (dragging) { e.preventDefault(); viewport.scrollLeft = startScroll - dx; }
    });
    window.addEventListener('mouseup', function () {
      if (!down) return;
      down = false;
      if (dragging) {
        viewport.classList.remove('is-dragging');
        viewport.addEventListener('click', function s(e) {
          e.stopPropagation(); e.preventDefault();
          viewport.removeEventListener('click', s, true);
        }, true);
      }
      dragging = false;
      pauseFor(1500);
    });

    prev.addEventListener('click', function () {
      var first = viewport.querySelector('.mh-dyn-tc-tile');
      var w = first ? first.getBoundingClientRect().width : 200;
      pauseFor(3000);
      mhMarqueeArrow(viewport, track, -1, (w + 14) * 3);
    });
    next.addEventListener('click', function () {
      var first = viewport.querySelector('.mh-dyn-tc-tile');
      var w = first ? first.getBoundingClientRect().width : 200;
      pauseFor(3000);
      mhMarqueeArrow(viewport, track, 1, (w + 14) * 3);
    });

    var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    // RTL uses the negative scrollLeft model — mirror with sgn or it freezes on /ar.
    function tick() {
      var sgn = mhIsRtlNow() ? -1 : 1;
      if (!paused) {
        viewport.scrollLeft += pxPerFrame * direction * sgn;
        var half = track.scrollWidth / 2;
        if (half > 0) {
          var pos = viewport.scrollLeft * sgn;          // magnitude 0..half
          if (direction > 0 && pos >= half) viewport.scrollLeft -= half * sgn;
          else if (direction < 0 && pos <= 0) viewport.scrollLeft += half * sgn;
        }
      }
      requestAnimationFrame(tick);
    }
    if (!prefersReduced) {
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if (direction < 0) {
            var half = track.scrollWidth / 2;
            if (half > 0) viewport.scrollLeft = half * (mhIsRtlNow() ? -1 : 1);
          }
          tick();
        });
      });
    }
    return true;
  };

  // ─────────────────────── banner_row ───────────────────────

  Renderers.banner_row = function (section, body) {
    var t = (section.tiles || [])[0];
    if (!t) return false;
    var a = document.createElement('a');
    a.href = t.href || '/';
    a.className = 'mh-dyn-banner-row';
    a.setAttribute('aria-label', t.title || 'Promotion');
    if (t.image_url) {
      var img = document.createElement('img');
      img.src = t.image_url; img.alt = t.title || '';
      img.setAttribute('loading', 'lazy');
      a.appendChild(img);
    }
    body.appendChild(a);
    return true;
  };

  // ─────────────────────── promo_strip ───────────────────────
  // A "Top Promo Strip" section is the SOURCE for the site-wide top ad
  // carousel (rendered in theme.liquid via the top-ad-carousel snippet, which
  // reads /api/top_ad_carousel.php). It must NOT render inline in the homepage
  // body too, or it would appear twice. So this renderer is a no-op.
  Renderers.promo_strip = function (section, body) {
    return false;
  };

  // ─────────────────────── two_column ───────────────────────

  Renderers.two_column = function (section, body) {
    var tiles = (section.tiles || []).slice(0, 2);
    if (!tiles.length) return false;
    var grid = document.createElement('div');
    grid.className = 'mh-dyn-2col-grid';
    tiles.forEach(function (t) {
      var a = document.createElement('a');
      a.href = t.href || '/';
      a.className = 'mh-dyn-2col-card';
      a.setAttribute('aria-label', t.title || '');
      if (t.image_url) {
        var img = document.createElement('img');
        img.src = t.image_url; img.alt = t.title || '';
        img.className = 'mh-dyn-2col-img';
        img.setAttribute('loading', 'lazy');
        a.appendChild(img);
      }
      if (t.title) {
        var label = document.createElement('div');
        label.className = 'mh-dyn-2col-label';
        var ttl = document.createElement('div');
        ttl.className = 'mh-dyn-2col-title';
        ttl.textContent = t.title;
        label.appendChild(ttl);
        if (t.subtitle) {
          var sub = document.createElement('div');
          sub.className = 'mh-dyn-2col-sub';
          sub.textContent = t.subtitle;
          label.appendChild(sub);
        }
        a.appendChild(label);
      }
      grid.appendChild(a);
    });
    body.appendChild(grid);
    return true;
  };

  // ─────────────────────── product_carousel ───────────────────────

  // Pull rendered cards out of an HTML string using a DOMParser. Limits to
  // known card-only nodes (Shopify-rendered, not user input).
  function extractProductCards(html, limit) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var nodes = doc.querySelectorAll('[data-cards-only] .cards-only-cell');
    var out = [];
    for (var i = 0; i < nodes.length && i < limit; i++) out.push(nodes[i]);
    return out;
  }

  function buildProductBanner(tile) {
    if (!tile || !tile.image_url) return null;
    var aside = document.createElement('aside');
    aside.className = 'mh-dyn-pc-banner';
    var img = document.createElement('img');
    img.src = tile.image_url; img.alt = tile.title || 'Banner';
    img.setAttribute('loading', 'lazy');
    if (tile.href) {
      var a = document.createElement('a');
      a.href = tile.href; a.setAttribute('aria-label', tile.title || 'Banner');
      a.appendChild(img);
      aside.appendChild(a);
    } else {
      aside.appendChild(img);
    }
    return aside;
  }

  // Build N skeleton cells so the carousel reserves height immediately
  // and the user sees shimmering placeholders instead of a blank gap.
  // Without this the section was `visibility: hidden` until the fetch
  // completed — perceived as "slow to load" because nothing was on
  // screen for 1-2 s.
  function buildPcSkeletonCells(track, count) {
    for (var i = 0; i < count; i++) {
      var cell = document.createElement('div');
      cell.className = 'mh-dyn-pc-cell mh-dyn-pc-skel';
      cell.setAttribute('aria-hidden', 'true');
      // Two layers: image area + 2 text lines. CSS animates background.
      var img = document.createElement('div'); img.className = 'mh-dyn-pc-skel-img';
      var ln1 = document.createElement('div'); ln1.className = 'mh-dyn-pc-skel-line mh-dyn-pc-skel-line--80';
      var ln2 = document.createElement('div'); ln2.className = 'mh-dyn-pc-skel-line mh-dyn-pc-skel-line--50';
      cell.appendChild(img); cell.appendChild(ln1); cell.appendChild(ln2);
      track.appendChild(cell);
    }
  }

  // SessionStorage cache for `cards-only` HTML. Repeat homepage visits
  // (back-button, internal nav back to /) skip the 1-2 s fetch entirely.
  // TTL kept short so admin-driven product changes show up quickly.
  var PC_CACHE_TTL_MS = 5 * 60 * 1000; // 5 minutes
  // Key includes the LANGUAGE: switching /ar → EN in the same tab used to
  // serve the cached Arabic card HTML on the English homepage until the TTL
  // expired ("Arabic products until I refresh").
  function pcCacheKey(handle) {
    var lang = /^\/ar(\/|$)/.test(location.pathname) ? 'ar' : 'en';
    return 'mh:pc:' + lang + ':' + handle;
  }
  function pcCacheGet(handle) {
    try {
      var raw = sessionStorage.getItem(pcCacheKey(handle));
      if (!raw) return null;
      var obj = JSON.parse(raw);
      if (!obj || (Date.now() - obj.t) > PC_CACHE_TTL_MS) return null;
      return obj.h || null;
    } catch (e) { return null; }
  }
  function pcCacheSet(handle, html) {
    // Cap stored size to avoid quota errors on big responses.
    if (!html || html.length > 800 * 1024) return;
    try { sessionStorage.setItem(pcCacheKey(handle), JSON.stringify({ t: Date.now(), h: html })); }
    catch (e) { /* quota exceeded — silent */ }
  }
  // One-time cleanup of pre-fix language-less cache entries.
  try {
    Object.keys(sessionStorage).forEach(function (k) {
      if (/^mh:pc:(?!ar:|en:)/.test(k)) sessionStorage.removeItem(k);
    });
  } catch (e) {}

  Renderers.product_carousel = function (section, body) {
    var cfg     = section.config || {};
    var handle  = cfg.collection_handle;
    var limit   = parseInt(cfg.product_limit, 10) || 12;
    var bpos    = cfg.banner_position || 'none';
    var byZone  = section.tiles_by_zone || {};
    var bannerTile = (byZone.banner || [])[0] || null;
    if (!handle) return false;

    // Populate the shared shell view-all if present.
    var shellViewAll = body.parentElement && body.parentElement.querySelector('.mh-dyn-viewall');
    if (shellViewAll) {
      shellViewAll.href = '/collections/' + encodeURIComponent(handle);
      shellViewAll.hidden = false;
    }

    var pcBody = document.createElement('div');
    pcBody.className = 'mh-dyn-pc-body';

    // Optional left banner
    if (bannerTile && bpos === 'left') {
      var leftBanner = buildProductBanner(bannerTile);
      if (leftBanner) pcBody.appendChild(leftBanner);
    }

    var carouselWrap = document.createElement('div');
    carouselWrap.className = 'mh-dyn-pc-wrap';
    var prev = makeArrow('prev');
    prev.classList.add('mh-dyn-pc-arrow', 'mh-dyn-pc-arrow--prev');
    prev.classList.remove('mh-dyn-arrow', 'mh-dyn-arrow--prev');
    var next = makeArrow('next');
    next.classList.add('mh-dyn-pc-arrow', 'mh-dyn-pc-arrow--next');
    next.classList.remove('mh-dyn-arrow', 'mh-dyn-arrow--next');
    carouselWrap.appendChild(prev);
    var track = document.createElement('div');
    track.className = 'mh-dyn-pc-track';
    carouselWrap.appendChild(track);
    carouselWrap.appendChild(next);
    pcBody.appendChild(carouselWrap);

    // Optional right banner
    if (bannerTile && bpos === 'right') {
      var rightBanner = buildProductBanner(bannerTile);
      if (rightBanner) pcBody.appendChild(rightBanner);
    }

    body.appendChild(pcBody);

    // Section stays visible from the start — skeleton cells fill the
    // track so the slot has its final height before the fetch resolves.
    // (Previously `visibility: hidden` on the wrapper hid the entire
    // section, which the user perceived as "slow loading".)
    buildPcSkeletonCells(track, Math.min(limit, 8));

    var sectionWrapper = body.closest('.mh-dyn-section');
    sectionWrapper && sectionWrapper.setAttribute('data-pc-state', 'loading');

    function injectCards(html) {
      var cards = extractProductCards(html, limit);
      cards = applyManualOrder(cards);
      if (!cards.length) {
        if (sectionWrapper) sectionWrapper.style.display = 'none';
        return;
      }
      // Wipe skeletons in one pass, then insert real cards.
      while (track.firstChild) track.removeChild(track.firstChild);
      cards.forEach(function (cellNode) {
        var cell = document.createElement('div');
        cell.className = 'mh-dyn-pc-cell';
        while (cellNode.firstChild) cell.appendChild(cellNode.firstChild);
        track.appendChild(cell);
      });
      sectionWrapper && sectionWrapper.setAttribute('data-pc-state', 'ready');

      prev.addEventListener('click', function () { mhCarScroll(track, -1); });
      next.addEventListener('click', function () { mhCarScroll(track, 1); });
      track.addEventListener('scroll', function () { mhCarSync(track, prev, next); }, { passive: true });
      mhCarSync(track, prev, next);

      // Re-trigger global hydrators (badges, quick-add, etc).
      try {
        window.dispatchEvent(new CustomEvent('mh:product-cards-injected', { detail: { container: track } }));
      } catch (e) {}
    }

    // ── Manual product order (admin → Featured Product Order) ──────────
    // Re-sorts the cards-only fetch to a staff-defined order. Degrades to
    // the native Shopify collection order when no manual order is set or
    // the API is unreachable, so this can NEVER break the carousel.
    var manualOrderMap = null; // { shopify_id(str): rank }
    function applyManualOrder(cards) {
      if (!manualOrderMap) return cards;
      return cards
        .map(function (node, i) {
          var idEl = (node.matches && node.matches('[data-product-id]'))
            ? node
            : (node.querySelector ? node.querySelector('[data-product-id]') : null);
          var pid = idEl ? idEl.getAttribute('data-product-id') : null;
          var rank = (pid != null && manualOrderMap[pid] != null) ? manualOrderMap[pid] : (1000000 + i);
          return { node: node, rank: rank, i: i };
        })
        .sort(function (a, b) { return (a.rank - b.rank) || (a.i - b.i); })
        .map(function (x) { return x.node; });
    }
    function loadManualOrder() {
      try {
        var raw = sessionStorage.getItem('mh:pco:' + handle);
        if (raw) { var o = JSON.parse(raw); if (o && (Date.now() - o.t) < 300000) { manualOrderMap = o.m || {}; return Promise.resolve(); } }
      } catch (e) {}
      return fetch('https://admin.menahub.com/api/featured_collection_order.php?handle=' + encodeURIComponent(handle), { credentials: 'omit' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          var m = {};
          if (j && j.order && j.order.length) { j.order.forEach(function (sid, idx) { m[String(sid)] = idx; }); }
          manualOrderMap = m;
          try { sessionStorage.setItem('mh:pco:' + handle, JSON.stringify({ t: Date.now(), m: m })); } catch (e) {}
        })
        .catch(function () { manualOrderMap = {}; });
    }

    function doFetch() {
      // Load the manual order first (tiny, cached), then render. manualOrderMap
      // is always set (even to {} on failure) so applyManualOrder is a no-op
      // when no custom order exists.
      loadManualOrder().then(function () {
        // Cache hit -> render immediately, no network.
        var cached = pcCacheGet(handle);
        if (cached) { injectCards(cached); return; }

        fetch((mhIsAr ? '/ar' : '') + '/collections/' + encodeURIComponent(handle) + '?view=cards-only', { credentials: 'same-origin', cache: 'no-store' })
          .then(function (r) { return r.ok ? r.text() : null; })
          .then(function (html) {
            if (!html) {
              // 404 / non-OK — collapse the section silently. This handles
              // stale admin handles pointing at deleted Shopify collections.
              if (sectionWrapper) sectionWrapper.style.display = 'none';
              return;
            }
            pcCacheSet(handle, html);
            injectCards(html);
          })
          .catch(function () {
            if (sectionWrapper) sectionWrapper.style.display = 'none';
          });
      });
    }

    // Lazy-load: only fetch when the section is near the viewport.
    // Saves 3 fetches above the fold on first paint (perfume, medical,
    // any other below-fold carousels) and dramatically improves the
    // initial network waterfall. Top carousel still loads immediately
    // because it's already in view when the observer attaches.
    if ('IntersectionObserver' in window && sectionWrapper) {
      var io = new IntersectionObserver(function (entries) {
        if (entries.some(function (e) { return e.isIntersecting; })) {
          io.disconnect();
          doFetch();
        }
      }, { rootMargin: '1400px 0px' /* prefetch well before entry: the cards-only
            render is ~4s, so near-top carousels (Beat the Heat / New Arrivals)
            start fetching almost immediately and in parallel rather than waiting
            for the user to scroll within 300px. */ });
      io.observe(sectionWrapper);
    } else {
      doFetch();
    }

    return true;
  };

  // ─────────────────────── triple_zone_mega_deals ───────────────────────

  function lumaOf(hex) {
    var c = (hex || '').replace('#', '');
    if (c.length !== 6) return 1;
    var r = parseInt(c.slice(0, 2), 16);
    var g = parseInt(c.slice(2, 4), 16);
    var b = parseInt(c.slice(4, 6), 16);
    return (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  }

  // Apply gradient + dark/light flag for sections that need
  // contrast-aware text (only triple_zone_mega_deals today).
  function applyMegaGradient(wrapper, section) {
    var s = section.bg_gradient_start;
    var e = section.bg_gradient_end;
    if (!s || !e) return;
    var avg = (lumaOf(s) + lumaOf(e)) / 2;
    wrapper.classList.add(avg > 0.6 ? 'mh-dyn-section--gradient-light' : 'mh-dyn-section--gradient-dark');
  }

  function megaZoneHeader(text, allLinkUrl, countdownEnd) {
    if (!text && !allLinkUrl) return null;
    var hdr = document.createElement('div');

    if (countdownEnd) {
      // 3-col grid: heading (left) | countdown (center) | ALL DEALS (right)
      hdr.className = 'mh-dyn-mega-zone-hdr mh-dyn-mega-zone-hdr--center';

      // Col 1: heading
      var h = document.createElement('h2');
      h.className = 'mh-dyn-mega-zone-title';
      h.textContent = text || '';
      hdr.appendChild(h);

      // Col 2: D:H:M:S segments
      var segs = document.createElement('div');
      segs.className = 'mh-dyn-mega-countdown-segs';
      segs.setAttribute('data-end', countdownEnd);
      ['d','h','m','s'].forEach(function(unit, idx) {
        if (idx > 0) {
          var colon = document.createElement('span');
          colon.className = 'mh-dyn-mega-cd-colon';
          colon.textContent = ':';
          segs.appendChild(colon);
        }
        var seg = document.createElement('div');
        seg.className = 'mh-dyn-mega-cd-seg';
        var num = document.createElement('span');
        num.className = 'mh-dyn-mega-cd-num';
        num.setAttribute('data-cd-unit', unit);
        num.textContent = '00';
        var lbl = document.createElement('span');
        lbl.className = 'mh-dyn-mega-cd-lbl';
        lbl.textContent = mhIsAr ? ({ d: 'ي', h: 'س', m: 'د', s: 'ث' }[unit]) : unit.toUpperCase();
        seg.appendChild(num);
        seg.appendChild(lbl);
        segs.appendChild(seg);
      });
      hdr.appendChild(segs);
      tickMegaCountdownSegs(segs);

      // Col 3: ALL DEALS link (or empty spacer to keep grid balanced)
      if (allLinkUrl) {
        var a = document.createElement('a');
        a.href = allLinkUrl;
        a.className = 'mh-dyn-mega-all-link';
        a.textContent = mhIsAr ? 'كل العروض' : 'ALL DEALS';
        hdr.appendChild(a);
      } else {
        hdr.appendChild(document.createElement('span'));
      }
    } else {
      // Standard: title left, link right
      hdr.className = 'mh-dyn-mega-zone-hdr';
      var h = document.createElement('h2');
      h.className = 'mh-dyn-mega-zone-title';
      h.textContent = text || '';
      hdr.appendChild(h);
      if (allLinkUrl) {
        var a = document.createElement('a');
        a.href = allLinkUrl;
        a.className = 'mh-dyn-mega-all-link';
        a.textContent = mhIsAr ? 'كل العروض' : 'ALL DEALS';
        hdr.appendChild(a);
      }
    }
    return hdr;
  }

  // Countdown timer BAR — rendered on TOP of the center cards panel (instead of
  // beside the heading). Full-width, rounded top corners connect to the panel.
  function buildMegaTimerBar(countdownEnd, allDealsUrl) {
    if (!countdownEnd && !allDealsUrl) return null;
    var ns = 'http://www.w3.org/2000/svg';
    var bar = document.createElement('div');
    bar.className = 'mh-dyn-mega-timerbar';

    // LEFT: bolt + "DEAL ENDS IN" + D:H:M:S segments
    var left = document.createElement('div');
    left.className = 'mh-dyn-mega-tb-left';
    if (countdownEnd) {
      var label = document.createElement('span');
      label.className = 'mh-dyn-mega-tb-label';
      var bolt = document.createElementNS(ns, 'svg');
      bolt.setAttribute('class', 'mh-dyn-mega-tb-bolt');
      bolt.setAttribute('viewBox', '0 0 24 24'); bolt.setAttribute('fill', 'currentColor');
      var bp = document.createElementNS(ns, 'path');
      bp.setAttribute('d', 'M13 2L3 14h8l-1 8 10-12h-8l1-8z'); bolt.appendChild(bp);
      var txt = document.createElement('span'); txt.textContent = mhIsAr ? 'ينتهي العرض خلال' : 'DEAL ENDS IN';
      label.appendChild(bolt); label.appendChild(txt);
      left.appendChild(label);

      var segs = document.createElement('div');
      segs.className = 'mh-dyn-mega-countdown-segs';
      segs.setAttribute('data-end', countdownEnd);
      ['d', 'h', 'm', 's'].forEach(function (unit, idx) {
        if (idx > 0) {
          var colon = document.createElement('span');
          colon.className = 'mh-dyn-mega-cd-colon'; colon.textContent = ':';
          segs.appendChild(colon);
        }
        var seg = document.createElement('div'); seg.className = 'mh-dyn-mega-cd-seg';
        var num = document.createElement('span'); num.className = 'mh-dyn-mega-cd-num';
        num.setAttribute('data-cd-unit', unit); num.textContent = '00';
        var lbl = document.createElement('span'); lbl.className = 'mh-dyn-mega-cd-lbl';
        lbl.textContent = mhIsAr ? ({ d: 'ي', h: 'س', m: 'د', s: 'ث' }[unit]) : unit.toUpperCase();
        seg.appendChild(num); seg.appendChild(lbl); segs.appendChild(seg);
      });
      left.appendChild(segs);
      tickMegaCountdownSegs(segs);
    }
    bar.appendChild(left);

    // RIGHT: ALL DEALS button (white pill on the orange bar)
    if (allDealsUrl) {
      var a = document.createElement('a');
      a.href = allDealsUrl;
      a.className = 'mh-dyn-mega-tb-all';
      a.textContent = mhIsAr ? 'كل العروض' : 'ALL DEALS';
      bar.appendChild(a);
    }
    return bar;
  }

  function extractBrand(title) {
    if (!title) return '';
    var first = (title.split('|')[0] || '').trim();
    return (first.length > 0 && first.length <= 16) ? first : '';
  }

  function tickMegaCountdown(el) {
    var endIso = el.getAttribute('data-end');
    if (!endIso) return;
    var end = new Date(endIso).getTime();
    if (isNaN(end)) return;
    function update() {
      var diff = Math.max(0, end - Date.now());
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      el.textContent = 'Ends in ' +
        (d > 0 ? (d + 'd ') : '') +
        (h < 10 ? '0' + h : h) + ':' +
        (m < 10 ? '0' + m : m) + ':' +
        (s < 10 ? '0' + s : s);
      if (diff > 0) setTimeout(update, 1000);
    }
    update();
  }

  function tickMegaCountdownSegs(el) {
    var endIso = el.getAttribute('data-end');
    if (!endIso) return;
    var end = new Date(endIso).getTime();
    if (isNaN(end)) return;
    var spans = {
      d: el.querySelector('[data-cd-unit="d"]'),
      h: el.querySelector('[data-cd-unit="h"]'),
      m: el.querySelector('[data-cd-unit="m"]'),
      s: el.querySelector('[data-cd-unit="s"]')
    };
    function pad(n) { return n < 10 ? '0' + n : String(n); }
    function update() {
      var diff = Math.max(0, end - Date.now());
      if (spans.d) spans.d.textContent = pad(Math.floor(diff / 86400000));
      if (spans.h) spans.h.textContent = pad(Math.floor((diff % 86400000) / 3600000));
      if (spans.m) spans.m.textContent = pad(Math.floor((diff % 3600000) / 60000));
      if (spans.s) spans.s.textContent = pad(Math.floor((diff % 60000) / 1000));
      if (diff > 0) setTimeout(update, 1000);
    }
    update();
  }

  Renderers.triple_zone_mega_deals = function (section, body) {
    var zones = section.tiles_by_zone || {};
    var cfg = section.config || {};
    if (!zones.left && !zones.center && !zones.right) return false;

    // Tag wrapper for gradient luma class (used by CSS for dark/light text).
    var wrapper = body.closest('.mh-dyn-section');
    if (wrapper) applyMegaGradient(wrapper, section);

    var grid = document.createElement('div');
    grid.className = 'mh-dyn-mega-grid';

    // Left zone — heading + 4 category cards (2x2)
    var leftCol = document.createElement('div');
    leftCol.className = 'mh-dyn-mega-col';
    var leftHdr = megaZoneHeader(mhIsAr ? 'أسباب إضافية للتسوّق' : (cfg.left_heading || 'More reasons to shop'), null);
    if (leftHdr) leftCol.appendChild(leftHdr);
    var leftGrid = document.createElement('div');
    leftGrid.className = 'mh-dyn-mega-left';
    (zones.left || []).slice(0, 4).forEach(function (t) {
      var card = document.createElement('a');
      card.href = t.href || '/'; card.className = 'mh-dyn-mega-cat';
      if (t.image_url) {
        var img = document.createElement('img');
        img.src = t.image_url; img.alt = t.title || '';
        img.setAttribute('loading', 'lazy');
        card.appendChild(img);
      }
      var bd = document.createElement('div');
      bd.className = 'mh-dyn-mega-cat-body';
      var ttl = document.createElement('div');
      ttl.className = 'mh-dyn-mega-cat-title';
      ttl.textContent = t.title || '';
      bd.appendChild(ttl);
      if (t.subtitle) {
        var sub = document.createElement('div');
        sub.className = 'mh-dyn-mega-cat-sub';
        sub.textContent = t.subtitle;
        bd.appendChild(sub);
      }
      card.appendChild(bd);
      leftGrid.appendChild(card);
    });
    leftCol.appendChild(leftGrid);
    grid.appendChild(leftCol);

    // Center zone — heading row (with inline countdown if set) + product cards
    var centerCol = document.createElement('div');
    centerCol.className = 'mh-dyn-mega-col';
    // Heading removed: the orange timer bar (built below) IS the center column's
    // header — it sits at the same level as the left/right zone headings and
    // carries the countdown (left) + ALL DEALS button (right).
    var center = document.createElement('div');
    center.className = 'mh-dyn-mega-center';
    var prodGrid = document.createElement('div');
    // Dynamic layout: cap by configured center_layout (max=4) but never render
    // more empty slots than available tiles. So 2 tiles in a 4-cap render as
    // 2 (single row, proper proportions); 4 tiles render as 2x2 squares.
    var maxLayout = cfg.center_layout === '4' ? 4 : 2;
    var actualTiles = (zones.center || []).slice(0, maxLayout);
    var actualCount = actualTiles.length;
    // The CSS class drives the grid template — pick the one matching what we
    // actually render, not what was configured.
    var layoutClass = actualCount >= 4 ? '4' : (actualCount >= 2 ? '2' : '1');
    prodGrid.className = 'mh-dyn-mega-products mh-dyn-mega-products--' + layoutClass;
    prodGrid.setAttribute('data-tile-count', String(actualCount));
    // Render each tile as the REAL product card (product-card-new) so Mega Deals
    // cards match the rest of the site — wishlist heart, quick-add (+), rating,
    // "sold", "Lowest price in 30 days" and the delivery badge. Fetch the card
    // via the ?view=megacard alternate product template and inject it; the global
    // mh:product-cards-injected listener (in product-card-new) wires up the
    // wishlist / quick-add / carousel, and the fulfilment hydrator paints the
    // delivery badge. Cards are Shopify-rendered (trusted), parsed with DOMParser
    // and appended as nodes — no innerHTML of fetched markup.
    function parseMegaCard(html) {
      try { return new DOMParser().parseFromString(html, 'text/html').querySelector('.mh-card'); }
      catch (e) { return null; }
    }
    function clearNode(n) { while (n.firstChild) n.removeChild(n.firstChild); }
    // A curated tile can point to a product that does NOT exist on this store
    // (the Saudi homepage is cloned from Qatar, whose product handles may not be
    // synced here) → the ?view=megacard fetch 404s. Instead of leaving an empty
    // grey skeleton slot, drop the cell and re-flow the grid so the products that
    // DO resolve fill the row cleanly (2→1 etc.).
    function dropMegaCell(cell) {
      if (cell && cell.parentNode) cell.parentNode.removeChild(cell);
      var n = prodGrid.children.length;
      var lc = n >= 4 ? '4' : (n >= 2 ? '2' : '1');
      prodGrid.className = 'mh-dyn-mega-products mh-dyn-mega-products--' + lc;
      prodGrid.setAttribute('data-tile-count', String(n));
    }
    actualTiles.forEach(function (t) {
      var cell = document.createElement('div');
      cell.className = 'mh-dyn-mega-cell';
      var skel = document.createElement('div');
      skel.className = 'mh-dyn-mega-cell-skel';
      cell.appendChild(skel);
      prodGrid.appendChild(cell);

      var hrefMatch = (t.href || '').match(/(?:^|\/)products\/([^/?#]+)/);
      var handle = hrefMatch ? hrefMatch[1] : null;
      if (!handle) { dropMegaCell(cell); return; }
      fetch((mhIsAr ? '/ar' : '') + '/products/' + encodeURIComponent(handle) + '?view=megacard', { credentials: 'same-origin', cache: 'no-store' })
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (html) {
          if (!html) { dropMegaCell(cell); return; }
          var realCard = parseMegaCard(html);
          if (!realCard) { dropMegaCell(cell); return; }
          // With credentials:'include' the /ar fetch carries the locale cookie so
          // the fragment (incl. the product title) renders in Arabic. These are a
          // safety net for any hardcoded labels not covered by is_ar in the template.
          if (mhIsAr) {
            var sc = realCard.querySelector('.mh-sold-count');
            if (sc) sc.textContent = sc.textContent.replace(/\bsold\b/i, 'مُباع');
            var oos = realCard.querySelector('.mh-card-oos-bar');
            if (oos && /Out of Stock/i.test(oos.textContent)) {
              oos.childNodes.forEach(function (n) { if (n.nodeType === 3 && /Out of Stock/i.test(n.nodeValue)) n.nodeValue = ' نفد المخزون'; });
            }
          }
          clearNode(cell);
          cell.appendChild(realCard);
          try {
            window.dispatchEvent(new CustomEvent('mh:product-cards-injected', { detail: { container: cell } }));
          } catch (e) {}
        })
        .catch(function () { dropMegaCell(cell); });
    });
    // Countdown timer bar on top of the cards (curved corners → panel border).
    var tbar = buildMegaTimerBar(cfg.countdown_end || null, cfg.all_deals_url || null);
    // Timer bar stays INSIDE the panel — one unified box. The box is nudged down
    // (margin-top in CSS) so it top-aligns with the left/right boxes that sit
    // below their text headers.
    if (tbar) center.appendChild(tbar);
    center.appendChild(prodGrid);
    centerCol.appendChild(center);
    grid.appendChild(centerCol);

    // Right zone — heading + 2 stacked banners
    var rightCol = document.createElement('div');
    rightCol.className = 'mh-dyn-mega-col';
    var rightHdr = megaZoneHeader(mhIsAr ? 'تحت الضوء' : (cfg.right_heading || 'In focus'), null);
    if (rightHdr) rightCol.appendChild(rightHdr);
    var rightGrid = document.createElement('div');
    rightGrid.className = 'mh-dyn-mega-right';
    var rightBanners = (zones.right || []);
    function makeRightBanner(t, hidden) {
      var card = document.createElement('a');
      card.href = t.href || '/'; card.className = 'mh-dyn-mega-banner';
      if (hidden) card.setAttribute('aria-hidden', 'true');
      if (t.image_url) {
        var img = document.createElement('img');
        img.src = t.image_url; img.alt = t.title || '';
        img.setAttribute('loading', 'lazy');
        card.appendChild(img);
      }
      return card;
    }
    var rightTrack = document.createElement('div');
    rightTrack.className = 'mh-dyn-mega-right-track';
    rightBanners.forEach(function (t) { rightTrack.appendChild(makeRightBanner(t, false)); });
    // 3+ banners → continuous vertical marquee (desktop). 1–2 → static stack.
    if (rightBanners.length > 2) {
      rightGrid.classList.add('mh-dyn-mega-right--marquee');
      rightBanners.forEach(function (t) { rightTrack.appendChild(makeRightBanner(t, true)); });
      rightTrack.style.animationDuration = Math.max(16, rightBanners.length * 5) + 's';
    }

    // ── Mobile infinite-loop drag/swipe carousel (phones) ────────────
    // On <=768px the "In focus" banners become a continuous loop carousel:
    // swipe by touch or drag by mouse, BOTH directions with no dead-end,
    // arrows, and auto-advance. Independent of the desktop vertical marquee
    // (which owns the track at >=1025px). Clones are hidden on desktop.
    if (rightBanners.length > 1) {
      rightGrid.classList.add('mh-dyn-mega-right--mcar');
      var megaArrows = mhMakeArrows(rightGrid);
      mhLoopCarousel(rightTrack, rightBanners.length, window.matchMedia('(max-width: 768px)'), {
        cloneClass: 'mh-dyn-mega-banner',
        prevBtn: megaArrows.prevBtn,
        nextBtn: megaArrows.nextBtn
      });
    }

    rightGrid.appendChild(rightTrack);
    rightCol.appendChild(rightGrid);
    grid.appendChild(rightCol);

    body.appendChild(grid);
    return true;
  };

  // ─────────────────────── tab_with_products ───────────────────────

  Renderers.tab_with_products = function (section, body) {
    var tiles = section.tiles || [];
    if (!tiles.length) return false;

    var cfg = section.config || {};
    var defaultLimit = parseInt(cfg.default_limit, 10) || 12;
    var DESIGN_KEYS = ['theme-orange','theme-blue','theme-pink','theme-green','theme-purple'];
    var cache = {};

    // Use the shared shell's view-all anchor (right side of header)
    var viewAll = body.parentElement && body.parentElement.querySelector('.mh-dyn-viewall');

    var tabsWrap = document.createElement('div');
    tabsWrap.className = 'mh-dyn-tp-tabs-wrap';
    var tabsEl = document.createElement('div');
    tabsEl.className = 'mh-dyn-tp-tabs';
    tabsEl.setAttribute('role', 'tablist');
    tabsWrap.appendChild(tabsEl);
    body.appendChild(tabsWrap);

    var panelArea = document.createElement('div');
    panelArea.className = 'mh-dyn-tp-panel-area';
    var prev = makeArrow('prev');
    prev.classList.add('mh-dyn-tp-arrow', 'mh-dyn-tp-arrow--prev');
    prev.classList.remove('mh-dyn-arrow', 'mh-dyn-arrow--prev');
    var next = makeArrow('next');
    next.classList.add('mh-dyn-tp-arrow', 'mh-dyn-tp-arrow--next');
    next.classList.remove('mh-dyn-arrow', 'mh-dyn-arrow--next');
    var panelWrap = document.createElement('div');
    panelWrap.className = 'mh-dyn-tp-panel-wrap';
    var coverEl = document.createElement('span');
    coverEl.className = 'mh-dyn-tp-tab-cover';
    coverEl.setAttribute('aria-hidden', 'true');
    var track = document.createElement('div');
    track.className = 'mh-dyn-tp-track';
    panelWrap.appendChild(coverEl);
    panelWrap.appendChild(track);
    panelArea.appendChild(prev);
    panelArea.appendChild(panelWrap);
    panelArea.appendChild(next);
    body.appendChild(panelArea);

    function loadTab(handle, limit) {
      track.setAttribute('data-loading', '1');
      while (track.firstChild) track.removeChild(track.firstChild);
      var skelCount = window.matchMedia('(max-width: 640px)').matches ? 3
                    : window.matchMedia('(max-width: 1024px)').matches ? 4
                    : 5;
      for (var s = 0; s < skelCount; s++) {
        var sk = document.createElement('div');
        sk.className = 'mh-dyn-tp-skel-card';
        track.appendChild(sk);
      }
      function inject(cells) {
        track.removeAttribute('data-loading');
        while (track.firstChild) track.removeChild(track.firstChild);
        cells.slice(0, limit).forEach(function (cellNode) {
          var cell = document.createElement('div');
          cell.className = 'mh-dyn-tp-cell';
          var clone = cellNode.cloneNode(true);
          while (clone.firstChild) cell.appendChild(clone.firstChild);
          track.appendChild(cell);
        });
        try {
          window.dispatchEvent(new CustomEvent('mh:product-cards-injected', { detail: { container: track } }));
        } catch (e) {}
      }
      if (cache[handle]) { inject(cache[handle]); return; }
      var url = (mhIsAr ? '/ar' : '') + '/collections/' + encodeURIComponent(handle) + '?view=cards-only';
      fetch(url, { credentials: 'same-origin', cache: 'no-store' })
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (html) {
          if (!html) { track.removeAttribute('data-loading'); return; }
          var cards = extractProductCards(html, 50);
          cache[handle] = cards;
          inject(cards);
        })
        .catch(function () { track.removeAttribute('data-loading'); });
    }

    function positionTabCover(btn) {
      if (!btn) return;
      var btnRect = btn.getBoundingClientRect();
      var panelRect = panelWrap.getBoundingClientRect();
      var left = btnRect.left - panelRect.left - 2;
      var width = btnRect.width + 4;
      // Set literal left/width (NOT custom props): var(--tp-cover-*) resolves
      // to its fallback 0 on this page, collapsing the cover. Literals are
      // reliable and still animate via the rule's `transition`.
      coverEl.style.left  = left + 'px';
      coverEl.style.width = width + 'px';
    }

    function applyPanelTheme(btn) {
      if (!btn) return;
      var bs = getComputedStyle(btn);
      var accent  = bs.getPropertyValue('--tp-accent').trim() || '#e28534';
      var pattern = bs.getPropertyValue('--tp-pattern').trim();
      var soft = accent;
      var softOpaque = '#ffffff';
      var hexMatch = accent.match(/^#([0-9a-f]{6})$/i);
      if (hexMatch) {
        var n = parseInt(hexMatch[1], 16);
        var r = (n >> 16) & 255, g = (n >> 8) & 255, b = n & 255;
        soft = 'rgba(' + r + ',' + g + ',' + b + ',0.04)';
        var or = Math.round(r * 0.04 + 255 * 0.96);
        var og = Math.round(g * 0.04 + 255 * 0.96);
        var ob = Math.round(b * 0.04 + 255 * 0.96);
        softOpaque = 'rgb(' + or + ',' + og + ',' + ob + ')';
      }
      panelWrap.style.setProperty('--tp-active-accent', accent);
      panelWrap.style.setProperty('--tp-active-soft', soft);
      panelWrap.style.setProperty('--tp-active-soft-opaque', softOpaque);
      if (pattern) panelWrap.style.setProperty('--tp-active-pattern', pattern);
      panelArea.style.setProperty('--tp-active-accent', accent);
    }

    function setActive(btn, t, opts) {
      tabsEl.querySelectorAll('.mh-dyn-tp-tab').forEach(function (b) { b.setAttribute('aria-selected', 'false'); });
      btn.setAttribute('aria-selected', 'true');
      applyPanelTheme(btn);
      positionTabCover(btn);
      if (viewAll && t.href) {
        viewAll.href = '/collections/' + encodeURIComponent(t.href);
        viewAll.hidden = false;
      }
      // scrollIntoView is only meaningful when the user clicks a tab —
      // it horizontally centres the picked tab in its scrollable strip.
      // On init we ALSO call setActive to mark the first tab as default
      // selected, but we MUST NOT scroll then: `block: 'nearest'` is
      // supposed to skip vertical scroll if the element is already
      // visible, but Chrome/Safari interpret it aggressively when the
      // tab lives in a scrollable container and end up smooth-scrolling
      // the entire document down to the tabs section. That makes the
      // page load "mid-page" on fresh URL hits — exactly the symptom
      // reported. The click-handler path passes no opts, so the scroll
      // still works for actual user interaction.
      if (opts && opts.skipScroll) return;
      if (btn.scrollIntoView) {
        try { btn.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' }); } catch (e) {}
      }
    }

    tiles.forEach(function (t, i) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'mh-dyn-tp-tab';
      var designKey = (t.image_url || '').trim();
      if (DESIGN_KEYS.indexOf(designKey) !== -1) {
        btn.classList.add('mh-dyn-tp-tab--' + designKey);
      }
      btn.setAttribute('role', 'tab');
      btn.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
      btn.textContent = t.title || ('Tab ' + (i + 1));
      btn.addEventListener('click', function () {
        setActive(btn, t);
        var lim = parseInt(t.subtitle, 10) || defaultLimit;
        loadTab(t.href || '', lim);
      });
      tabsEl.appendChild(btn);
    });

    var first = tiles[0];
    var firstBtn = tabsEl.querySelector('.mh-dyn-tp-tab');
    var firstLim = parseInt(first.subtitle, 10) || defaultLimit;
    loadTab(first.href || '', firstLim);
    // skipScroll: true on init — see setActive comment above. We want
    // the first tab marked aria-selected + theme applied, but NOT to
    // smooth-scroll the document down to where the tab sits.
    requestAnimationFrame(function () { setActive(firstBtn, first, { skipScroll: true }); });

    window.addEventListener('resize', function () {
      var active = tabsEl.querySelector('.mh-dyn-tp-tab[aria-selected="true"]');
      if (active) positionTabCover(active);
    });

    prev.addEventListener('click', function () { mhCarScroll(track, -1); });
    next.addEventListener('click', function () { mhCarScroll(track, 1); });

    return true;
  };

  // ─────────────────────── boot ───────────────────────

  // Map slug → outer Shopify section wrapper for any legacy non-dynamic
  // section that claims an admin slug (best-collection, featured-collection,
  // etc.). Used to RELOCATE those wrappers into admin position order so
  // the visual flow matches admin/homepage_sections, even though they
  // live in separate Shopify section wrappers in the template.
  function getLegacyWrappersBySlug() {
    var bySlug = {};
    Array.from(document.querySelectorAll('[data-admin-slug]')).forEach(function (el) {
      if (ROOT.contains(el)) return;
      var slug = el.getAttribute('data-admin-slug');
      if (!slug || bySlug[slug]) return;
      var wrapper = el.closest('[id^="shopify-section-"]');
      if (wrapper) bySlug[slug] = wrapper;
    });
    return bySlug;
  }

  // Prefer server-rendered inline data when present — eliminates the
  // post-paint fetch (and the layout shift it caused). Falls back to the
  // live fetch if the inline payload is missing or fails to parse.
  function mhGetHomepageData() {
    var el = document.getElementById('mh-homepage-data-inline');
    if (!el) return null;
    try {
      var data = JSON.parse(el.textContent || el.innerText || '');
      if (data && data.success) return data;
    } catch (e) {
      console.warn('[mh-homepage] inline JSON parse failed, falling back to fetch', e);
    }
    return null;
  }

  // A content fingerprint of the section list used to detect when the fast-paint
  // metafield snapshot has drifted from the live database (a category added,
  // removed, or reordered in admin). We hash only STRUCTURAL identity — each
  // section's slug/type plus the identity of every item/tile it contains — so
  // volatile top-level fields (timestamps, request nonces) never cause a false
  // "stale" verdict. When two signatures differ, an admin edit hasn't reached
  // the snapshot yet.
  function mhSectionsSignature(sections) {
    try {
      return (sections || []).map(function (s) {
        var items = s.items || s.products || s.tiles || s.cards || s.banners || [];
        // Fingerprint each item by identity + the admin-editable DISPLAY fields
        // (image, subtitle, badge/label, link). This catches an image-only or
        // badge-only edit on an EXISTING tile — identity/title alone would miss
        // it (tiles share the title "Furniture" but differ by image). Price and
        // stock are deliberately excluded: they drift live and would otherwise
        // cause false reloads. Sorted so a live re-sort of a product carousel
        // (e.g. best-sellers reshuffling) is NOT read as a change.
        var ids = Array.isArray(items) ? items.map(function (it) {
          if (!it) return '';
          var id = it.id || it.product_id || it.slug || it.handle || it.title || it.name || '';
          return [id,
                  it.image_url || it.image || it.img || '',
                  it.subtitle  || '',
                  it.label     || it.badge || '',
                  it.href      || it.url   || ''].join('~');
        }).sort().join(',') : '';
        return (s.slug || '') + ':' + (s.section_type || '') + ':' + ids;
      }).join('|');
    } catch (e) { return ''; }
  }

  // On Arabic, skip the inline (English) metafield payload and fetch the
  // Arabic homepage instead; English keeps the fast inline path.
  // Detect Arabic from the URL PATH first (always correct for /ar) — the html
  // lang attribute can be stale if Shopify serves a cached EN-rendered HTML for
  // the /ar URL, which would otherwise make headings/cards render English.
  var mhIsAr = /^\/ar(\/|$)/.test(location.pathname) || (document.documentElement.lang || '').indexOf('ar') === 0;
  // Dedicated Saudi store: ALWAYS request the Saudi market so homepage_full.php
  // returns Qatar's layout with Saudi-localized copy (Qatar→Saudi Arabia, QAR→SAR…).
  // (The mh_market cookie belongs to the Qatar single-store toggle, absent here.)
  var mhIsSa = true;

  // Self-heal flag: a previous load found the inline snapshot stale vs the live
  // DB and set this. While set (for the rest of the browser session) we bypass
  // the inline metafield entirely and render from the always-fresh API, so the
  // admin's edit shows even if Shopify never receives the updated snapshot.
  var mhForceFresh = false;
  try { mhForceFresh = sessionStorage.getItem('mh_home_force_fresh') === '1'; } catch (e) {}

  var inlineData = (mhIsAr || mhIsSa || mhForceFresh) ? null : mhGetHomepageData();

  // Stale-while-revalidate for the fetch path (/ar, Saudi — no inline
  // metafield): render instantly from the last payload cached in
  // localStorage, refresh it in the background for the NEXT view.
  // First-ever visits fall through to the live fetch (skeleton shows).
  var mhHomeCacheKey = 'mh_home_v1_' + (mhIsAr ? 'ar' : 'en') + '_' + (mhIsSa ? 'sa' : 'qa');
  var mhHomeUrl = 'https://admin.menahub.com/api/homepage_full.php' + (function () {
    var q = []; if (mhIsAr) q.push('lang=ar'); if (mhIsSa) q.push('market=sa');
    return q.length ? '?' + q.join('&') : '';
  })();
  function mhHomeFetchFresh() {
    return fetch(mhHomeUrl, { credentials: 'omit' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (d && d.success && Array.isArray(d.sections) && d.sections.length) {
          try { localStorage.setItem(mhHomeCacheKey, JSON.stringify({ _t: Date.now(), data: d })); } catch (e) {}
        }
        return d;
      });
  }
  var mhHomeCached = null;
  if (!inlineData) {
    try {
      var c = JSON.parse(localStorage.getItem(mhHomeCacheKey) || 'null');
      if (c && c._t && Date.now() - c._t < 1800000 && c.data && c.data.success) mhHomeCached = c.data;
    } catch (e) {}
  }
  var dataPromise;
  if (inlineData) {
    dataPromise = Promise.resolve(inlineData);
    // Reconcile the fast-paint snapshot against the live database. The metafield
    // is only an optimisation — the DB (served by homepage_full.php, cache
    // purged on every admin save) is the source of truth. If the section lists
    // diverge (an admin added/removed/reordered a category and the Shopify
    // metafield sync didn't land), flag a one-time fresh render and reload so
    // the edit appears WITHOUT any manual metafield resync. mhForceFresh then
    // keeps this session on the fresh path, so the reload happens at most once.
    mhHomeFetchFresh().then(function (fresh) {
      try {
        if (fresh && fresh.success && Array.isArray(fresh.sections) && fresh.sections.length &&
            mhSectionsSignature(fresh.sections) !== mhSectionsSignature(inlineData.sections)) {
          sessionStorage.setItem('mh_home_force_fresh', '1');
          location.reload();
        }
      } catch (e) {}
    });
  } else if (mhHomeCached) {
    dataPromise = Promise.resolve(mhHomeCached);
    mhHomeFetchFresh(); // background revalidate — next view is fresh
  } else {
    dataPromise = mhHomeFetchFresh();
  }

  function mhRemoveBootSkel() {
    var sk = ROOT.querySelector('[data-mh-boot-skel]');
    if (sk) sk.remove();
  }

  dataPromise
    .then(function (json) {
      mhRemoveBootSkel();
      if (!json || !json.success || !Array.isArray(json.sections)) return;
      var legacyBySlug = getLegacyWrappersBySlug();

      // The Shopify section wrapper that contains this dynamic renderer.
      // To get the admin order to flow as ONE list (with legacy wrappers
      // interleaved), we re-parent every relevant wrapper as a sibling
      // of ourWrapper, in admin order, by inserting each before the NEXT
      // sibling in that order. Anchor: ourWrapper itself (we move it last).
      var ourWrapper = ROOT.closest('[id^="shopify-section-"]');
      var parent = ourWrapper && ourWrapper.parentElement;
      if (!ourWrapper || !parent) return;

      // First pass: build all dynamic sections inside ROOT (they'll be
      // inside ourWrapper). Track mapping slug → built wrapper element.
      var dynamicBySlug = {};
      json.sections.forEach(function (section) {
        if (legacyBySlug[section.slug]) return;
        var renderer = Renderers[section.section_type];
        if (!renderer) return;
        var built = buildShell(section);
        var ok = renderer(section, built.body);
        if (ok !== false) {
          ROOT.appendChild(built.wrapper);
          dynamicBySlug[section.slug] = built.wrapper;
        }
      });

      // Second pass: walk admin order and physically move each section
      // to the correct position. For legacy wrappers we move the entire
      // shopify-section-* container; for dynamic-built sections we move
      // their .mh-dyn-section node into a per-slug position by anchoring
      // them to a stub div that shares ourWrapper's slot, then re-append
      // ourWrapper for each one (since we can't split ourWrapper itself).
      //
      // Simplification: append each legacy wrapper to `parent` in admin
      // order BEFORE ourWrapper, then push ourWrapper to the end —
      // dynamic-built sections stay grouped inside ourWrapper but are
      // re-ordered there so groups of consecutive dynamic sections sit
      // together at the position they were last hit in admin order.
      //
      // Better solution: for each admin-order section, if legacy, move
      // legacy wrapper to BEFORE ourWrapper; if dynamic, move ourWrapper
      // to current position (so all subsequent dynamic kids of ourWrapper
      // appear at this slot). This means consecutive dynamic sections
      // stay grouped (as one chunk inside ourWrapper) — which is correct
      // when admin places them consecutively. When admin interleaves a
      // legacy section between two dynamic ones, ourWrapper has to "split"
      // — handled by extracting the dynamic-built kids before that
      // legacy slot into a *new* sibling wrapper element of ourWrapper.

      // Implementation: walk admin order, building a "rail" of nodes to
      // append in sequence. Each node is either a legacy wrapper (moved
      // wholesale) or a freshly-created slot div containing accumulated
      // consecutive dynamic-built sections. We then insert every rail
      // node into `parent` right before ourWrapper, IN ORDER. ourWrapper
      // is repurposed at the end to host the final dynamic bucket (so
      // there's no orphan empty wrapper left in the DOM).
      while (ROOT.firstChild) ROOT.removeChild(ROOT.firstChild);

      var rail = [];
      var bucket = [];
      function commitBucket() {
        if (!bucket.length) return;
        var slot = document.createElement('div');
        slot.className = 'mh-dyn-flush-slot';
        slot.setAttribute('data-mh-dynamic-slot', '1');
        bucket.forEach(function (w) { slot.appendChild(w); });
        rail.push({ kind: 'dyn', node: slot });
        bucket = [];
      }
      json.sections.forEach(function (section) {
        var legacy = legacyBySlug[section.slug];
        if (legacy) {
          commitBucket();
          rail.push({ kind: 'legacy', node: legacy });
          return;
        }
        var built = dynamicBySlug[section.slug];
        if (built) bucket.push(built);
      });
      // Final bucket → load into ourWrapper itself (avoids empty wrapper).
      var hasFinalDyn = bucket.length > 0;
      if (hasFinalDyn) {
        bucket.forEach(function (w) { ROOT.appendChild(w); });
      }

      // Now physically position: detach ourWrapper, then insert every
      // rail node before what is currently the next sibling we'll mark.
      // Easiest: remove ourWrapper, append all rail nodes to parent in
      // order at ourWrapper's original index, then re-append ourWrapper
      // at the end as the final-bucket holder (or hide it if no dyn).
      var anchor = document.createComment('mh-dyn-anchor');
      parent.insertBefore(anchor, ourWrapper);
      parent.removeChild(ourWrapper);
      rail.forEach(function (entry) { parent.insertBefore(entry.node, anchor); });
      if (hasFinalDyn) {
        parent.insertBefore(ourWrapper, anchor);
      } else {
        // No final dynamic content — keep ourWrapper out of flow but
        // attached so Shopify's section lifecycle hooks don't break.
        ourWrapper.style.display = 'none';
        parent.insertBefore(ourWrapper, anchor);
      }
      parent.removeChild(anchor);

      // After the rearrange the browser's restored scroll position
      // points at the wrong content. Pin to top of homepage so a
      // refresh always lands at the hero.
      try { window.scrollTo(0, 0); } catch (e) {}
      // Reveal the homepage now that the section order is final —
      // body was opacity-locked from <head> to avoid the "scroll down
      // then snap up" flash on desktop refresh.
      if (typeof window.MhHomepageReveal === 'function') {
        requestAnimationFrame(function () { window.MhHomepageReveal(); });
      }

      // Signal to the CLS guard (top of this IIFE) that the renderer is
      // done — it measures + persists the rendered height for next visit,
      // then releases the min-height reservation.
      try {
        // Wait a tick for images to begin painting so scrollHeight is
        // closer to the real settled height.
        setTimeout(function () {
          window.dispatchEvent(new Event('mh:homepage-dyn-rendered'));
        }, 50);
      } catch (e) {}
    })
    .catch(function () {
      // Reveal even if the API call fails so the page never sits hidden.
      if (typeof window.MhHomepageReveal === 'function') window.MhHomepageReveal();
      try { window.dispatchEvent(new Event('mh:homepage-dyn-rendered')); } catch (e) {}
    });

  window.MhHomepageRenderers = Renderers;
})();
